/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {Filter} from "@mm-products/java-multima-framework";
import {taxGuruAxios} from "../axios";
import {taxClientUrls} from "../url";
import {TaxClientResult} from "../models/TaxClientResult";
import {TaxClientDto} from "../models/TaxClientDto";
import {TaxClientRequest} from "../models/TaxClientRequest";
import {TaxClientWizardDto} from "../models/TaxClientWizardDto";
import {TaxClientCorrectionDto} from "../models/TaxClientCorrectionDto";

export const listClients = (
    filter: Filter,
    signal?: AbortSignal,
    toastId?: string,
    noErrorToast?: boolean
): Promise<AxiosResponse<TaxClientResult>> => {
    return taxGuruAxios.post(taxClientUrls.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
        // @ts-ignore
        noErrorToast,
    });
};

export const toggleClientCorrection = (clientUid: string, state: boolean, signal?: AbortSignal, toastId?: string) => {
    return taxGuruAxios.post(taxClientUrls.correctionToggle(clientUid), undefined, {
        signal,
        params: {
            state,
        },
        // @ts-ignore
        toastId,
    });
};

export const calculateClientCorrection = (clientUid: string, state: boolean, signal?: AbortSignal, toastId?: string): Promise<TaxClientCorrectionDto> => {
    return taxGuruAxios
        .get(taxClientUrls.correctionCalculate(clientUid), {
            signal,
            params: {
                state,
            },
            // @ts-ignore
            toastId,
        })
        .then(({ data }) => data);
};

export const createClient = (taxClient: TaxClientRequest, toastId?: string): Promise<AxiosResponse<TaxClientDto>> => {
    return taxGuruAxios.post(taxClientUrls.create, taxClient, {
        // @ts-ignore
        toastId,
    });
};

export const createClientByWizard = (taxClientWizard: TaxClientWizardDto, toastId?: string): Promise<AxiosResponse<TaxClientDto>> => {
    return taxGuruAxios.post(taxClientUrls.createByWizard, taxClientWizard, {
        // @ts-ignore
        toastId,
    });
};

export const deleteClient = (taxClientId: string, toastId?: string): Promise<AxiosResponse<TaxClientDto>> => {
    return taxGuruAxios.delete(taxClientUrls.delete(encodeURIComponent(taxClientId)), {
        // @ts-ignore
        toastId,
    });
};

export const updateClient = (taxClientId: string, taxClient: TaxClientRequest, toastId?: string): Promise<AxiosResponse<TaxClientDto>> => {
    return taxGuruAxios.put(taxClientUrls.update(encodeURIComponent(taxClientId)), taxClient, {
        // @ts-ignore
        toastId,
    });
};

export const getClient = (taxClientId: string, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<TaxClientDto> => {
    return taxGuruAxios
        .get(taxClientUrls.get(encodeURIComponent(taxClientId)), {
            // @ts-ignore
            toastId,
            noErrorToast,
            signal,
        })
        .then((data) => data.data);
};
